import React, { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { useFormDialogStyles, FormDialogHeader, FormSection } from "../FormDialog";

const money = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Registra o recebimento de um agendamento concluído (mesma API do Financeiro).
const PaymentDialog = ({ appointment, onClose, onDone }) => {
  const classes = useFormDialogStyles();
  const [methods, setMethods] = useState([]);
  const [methodId, setMethodId] = useState("");
  const [paidAt, setPaidAt] = useState(moment().format("YYYY-MM-DDTHH:mm"));
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api
      .get("/payment-methods")
      .then(({ data }) => {
        const list = Array.isArray(data) ? data : [];
        setMethods(list);
        const def = list.find((m) => m.isDefault);
        if (def) setMethodId(def.id);
      })
      .catch(toastError);
  }, []);

  const submit = async () => {
    setSaving(true);
    try {
      const { data } = await api.post(`/transactions/appointments/${appointment.id}/confirm-payment`, {
        paymentMethodId: methodId || undefined,
        paidAt,
        notes: notes.trim() || undefined,
      });
      toast.success("Pagamento registrado.");
      onDone({
        transactionId: data.id,
        status: "paid",
        value: Number(data.value),
        paidAt: data.paidAt,
        paymentMethod: data.paymentMethod?.name ?? null,
      });
    } catch (err) {
      toastError(err);
    }
    setSaving(false);
  };

  return (
    <Dialog open onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth classes={{ paper: classes.paper }}>
      <FormDialogHeader
        title="Registrar pagamento"
        subtitle={`${appointment.contact?.name || "Cliente"} · ${appointment.service?.name || ""} · ${money(
          appointment.payment?.value ?? appointment.price ?? appointment.service?.price
        )}`}
        onClose={onClose}
        disabled={saving}
      />
      <DialogContent dividers className={classes.content}>
        <FormSection title="Recebimento">
          <TextField
            select
            variant="outlined"
            size="small"
            label="Forma de pagamento"
            value={methodId}
            onChange={(e) => setMethodId(e.target.value)}
          >
            <MenuItem value="">Não informar</MenuItem>
            {methods.map((m) => (
              <MenuItem key={m.id} value={m.id}>
                {m.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            variant="outlined"
            size="small"
            type="datetime-local"
            label="Pago em"
            value={paidAt}
            onChange={(e) => setPaidAt(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            variant="outlined"
            size="small"
            label="Observações (opcional)"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </FormSection>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button className={`${classes.actionButton} ${classes.cancelButton}`} onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          className={classes.actionButton}
          disabled={saving}
          onClick={submit}
        >
          {saving ? <CircularProgress size={20} color="inherit" /> : "Confirmar pagamento"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialog;
